import { IllustrationFrame, type IllustrationProps } from './IllustrationFrame';

/** A message bubble and sparkles; the accent is the large sparkle. */
export function IllustrationAssistant({ className }: IllustrationProps) {
  return (
    <IllustrationFrame className={className}>
      <path
        className="ds-ill-fill"
        d="M42 34H110A12 12 0 0 1 122 46V68A12 12 0 0 1 110 80H64L46 96V80H42A12 12 0 0 1 30 68V46A12 12 0 0 1 42 34Z"
      />
      <path className="ds-ill-line" d="M44 52H96M44 64H80" />
      <path
        className="ds-ill-accent"
        d="M128 14C129.5 24 134 28.5 144 30C134 31.5 129.5 36 128 46C126.5 36 122 31.5 112 30C122 28.5 126.5 24 128 14Z"
      />
      <path className="ds-ill-line" d="M138 52L139.5 56.5L144 58L139.5 59.5L138 64L136.5 59.5L132 58L136.5 56.5Z" />
    </IllustrationFrame>
  );
}
